import emotionNormalize from 'emotion-normalize'
import { css } from '@emotion/react'

import { borders } from 'src/theme/adSales/borders'

import type { ThemeStyles } from 'theme-ui'

export const globalStyles = css`
  ${emotionNormalize}

  @font-face {
    font-family: 'ReithSans';
    src: url(/fonts/BBCReithSans_W_Lt.woff2) format('woff2'),
      url(/fonts/BBCReithSans_W_Lt.woff) format('woff');
    font-weight: 100;
    font-display: swap;
  }

  @font-face {
    font-family: 'ReithSans';
    src: url(/fonts/BBCReithSans_W_Rg.woff2) format('woff2'),
      url(/fonts/BBCReithSans_W_Rg.woff) format('woff');
    font-weight: 400;
    font-display: swap;
  }

  @font-face {
    font-family: 'ReithSans';
    src: url(/fonts/BBCReithSans_W_It.woff2) format('woff2'),
      url(/fonts/BBCReithSans_W_It.woff) format('woff');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'ReithSans';
    src: url(/fonts/BBCReithSans_W_Md.woff2) format('woff2'),
      url(/fonts/BBCReithSans_W_Md.woff) format('woff');
    font-weight: 500;
    font-display: swap;
  }

  @font-face {
    font-family: 'ReithSans';
    src: url(/fonts/BBCReithSans_W_Bd.woff2) format('woff2'),
      url(/fonts/BBCReithSans_W_Bd.woff) format('woff');
    font-weight: 700;
    font-display: swap;
  }

  @font-face {
    font-family: 'ReithSans';
    src: url(/fonts/BBCReithSans_W_ExBd.woff2) format('woff2'),
      url(/fonts/BBCReithSans_W_ExBd.woff) format('woff');
    font-weight: 900;
    font-display: swap;
  }

    @font-face {
    font-family: 'ReithSans';
    src: url(/fonts/BBCReithSans_W_Lt.woff2) format('woff2'),
      url(/fonts/BBCReithSans_W_Lt.woff) format('woff');
    font-weight: 100;
    font-display: swap;
  }

  @font-face {
    font-family: 'ReithSerif';
    src: url(/fonts/BBCReithSerif_W_Rg.woff2) format('woff2'),
      url(/fonts/BBCReithSerif_W_Rg.woff) format('woff');
    font-weight: 400;
    font-display: swap;
  }

  @font-face {
    font-family: 'ReithSerif';
    src: url(/fonts/BBCReithSerif_W_It.woff2) format('woff2'),
      url(/fonts/BBCReithSerif_W_It.woff) format('woff');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'ReithSerif';
    src: url(/fonts/BBCReithSerif_W_Md.woff2) format('woff2')
    font-weight: 500;
    font-display: swap;
  }

  @font-face {
    font-family: 'ReithSerif';
    src: url(/fonts/BBCReithSerif_W_Bd.woff2) format('woff2'),
      url(/fonts/BBCReithSerif_W_Bd.woff) format('woff');
    font-weight: 700;
    font-display: swap;
  }

  @font-face {
    font-family: 'ReithSerif';
    src: url(/fonts/BBCReithSerif_W_ExBd.woff2) format('woff2'),
      url(/fonts/BBCReithSerif_W_ExBd.woff) format('woff');
    font-weight: 900;
    font-display: swap;
  }

  .tabFocusBlue, .tabFocusBlue * {
    :focus-visible {
      box-shadow: ${borders.activeButton}
    }
  }
}
`

export const themeUIElementStyles: ThemeStyles = {
  root: {
    fontFamily: 'bbc',
    lineHeight: 'body',
    fontWeight: 'normal',
    body: {
      textRendering: 'optimizeLegibility',
      WebkitOverflowScrolling: 'touch',
      wordBreak: 'break-word',
      overflowWrap: 'break-word'
    },
    '*:where(:not(iframe, canvas, img, svg, video, em):not(svg *))': {
      all: 'unset',
      display: 'revert'
    },
    '*,*::before,*::after': {
      boxSizing: 'border-box'
    },
    'ol, ul': {
      listStyle: 'none'
    },
    img: {
      maxWidth: '100%'
    },
    '.bullet-points': {
      ul: {
        listStyleType: 'disc',
        pl: 4,
        ml: 4
      },
      li: {
        my: 3
      }
    },
    table: {
      borderCollapse: 'collapse'
    },
    textarea: {
      whiteSpace: 'revert'
    }
  },
  h1: {
    variant: 'text.atlas',
    fontFamily: 'bbcserif',
    m: 0
  },
  h2: {
    variant: 'text.elephant',
    fontFamily: 'bbcserif',
    m: 0
  },
  h3: {
    variant: 'text.imperial',
    fontFamily: 'bbcserif',
    m: 0
  },
  h4: {
    variant: 'text.royal',
    fontFamily: 'bbcserif',
    m: 0
  },
  h5: {
    variant: 'text.foolscap',
    fontFamily: 'bbcserif',
    m: 0
  },
  h6: {
    variant: 'text.foolscap',
    fontFamily: 'bbcserif',
    m: 0
  },
  p: {
    variant: 'text.bodyCopy',
    lineHeight: 'body'
  },
  img: {
    maxWidth: '100%'
  },
  hr: {
    border: 'secondaryThin',
    maxWidth: '100%',
    mx: 'auto',
    my: 1
  },
  a: {
    cursor: 'pointer',
    color: 'inherit',
    textDecoration: 'inherit'
  },
  pre: {
    fontFamily: 'monospace',
    fontSize: 'metaData',
    p: 3,
    color: 'text.primary',
    bg: 'sunken',
    overflow: 'auto',
    borderRadius: '6px'
  },
  code: {
    fontFamily: 'monospace',
    fontSize: 'inherit',
    color: 'text.tertiary',
    bg: 'sunken',
    borderRadius: '3px',
    mx: 1,
    px: 1
  },
  li: {
    my: 2
  },
  table: {
    width: '100%',
    my: 6,
    borderCollapse: 'separate',
    borderSpacing: 0,
    'th,td': {
      textAlign: 'left',
      py: 1,
      pr: 1,
      pl: 0,
      borderColor: 'thinLight',
      borderBottomStyle: 'solid'
    }
  },
  th: {
    verticalAlign: 'bottom',
    borderBottomWidth: '1px'
  },
  td: {
    verticalAlign: 'top',
    borderBottomWidth: '0.5px'
  }
}
